import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../../assets/styles/containers/_templates.scss";
import "../../../assets/styles/containers/_templates2.scss";
import Typography from "@mui/material/Typography";
import CategoryDetails from "./CategoryDetails";
import { Grid } from "@mui/material";
import toast from "react-hot-toast";
import SettingsIcon from "@mui/icons-material/Settings";
import { useLocation, useNavigate } from "react-router-dom";
import InspectionDetails from "./TemplateAccord/InspectionDetails";
import { apiCall } from "../../utils/action";
import Preloader from "../../helpers/Preloader";
import useMediaQuery from "@mui/material/useMediaQuery";
import EditTemplateList from "../../components/templateListView/EditTemplateList";
import { timestamp, trimEditorHtml } from "../../utils/services";
import { updateCategoryData, updateTEData } from "../../store/action";
import { ratingListSignature, sortRatingsByOrder, stripDefaultRatingFromCategories } from "../../common/TemplateUtils/lineRatingUtils";
import store from "../../store/index";

const EditTemplate = (props) => {
  const isMobile = useMediaQuery("(max-width: 600px)");
  const { templateId, templateName } = props;
  const [CategoryList, setCategoryList] = useState([]);
  const [AllCategoryList, setAllCategoryList] = useState([]);
  const [isEdit, setIsEdit] = useState("");
  const [addNew, setAddNew] = useState(false);
  const handleCloseNew = () => setAddNew(false);
  const [showLoader, setShowLoader] = useState(false);
  const [isRename, setIsRename] = useState(false);
  const [loadDetails, setLoadDetails] = useState(0);
  const [load, setLoad] = useState(0);
  const [templateDetails, setTemplateDetails] = useState([]);
  const [outsideClick, setOutsideClick] = useState(false);
  const uuId = sessionStorage.getItem("user_id");
  const roleId = sessionStorage.getItem("role_id");
  const [templateRatingDetails, setTemplateRatingDetails] = useState([]);
  const [summary, setSummary] = useState({ innerHTML: "" });
  const [newCatList, setNewCatList] = useState([]);
  const companyId = sessionStorage.getItem("company_id");
  const [renId, setRenId] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [isFocused, setIsFocused] = useState(false);
  const [skeletonLoad, setSkeletonLoad] = useState(false);
  const [defaultTemplate, setDefaultTemplate] = useState(0);
  const [isAutoSaving, setIsAutoSaving] = useState(false);
  const [autoSave, setAutoSave] = useState(false);
  const [updateTemplateCall, queueUpdateTemplateCall] = useState([]);
  const [updateTemplateData, queueUpdateTemplateData] = useState([]);
  const [updatedData, setUpdatedData] = useState([]);
  const autoSaveRef = useRef(false);
  const AllCategoryListRef = useRef([]);
  const updateTemplateCallRef = useRef([]);
  const updateTemplateDataRef = useRef([]);
  const defaultRef = useRef(0);
  const templateIdRef = useRef(location.state?.id || templateId);
  const autoSavingCheck = 30000; // every 30 seconds
  const storeData = useSelector((state) => state.templates);
  const templateDataList = storeData?.templateData;
  const dispatch = useDispatch();
  // moved here so we can control all updates in this component
  const [reRender, setReRender] = useState(false);
  const [action, setAction] = useState("");
  const [showNavigationConfirm, setShowNavigationConfirm] = useState(false);
  const [isNavigatingAway, setIsNavigatingAway] = useState(false);

  const checkActiveFocus = () => setIsFocused(true);

  const renamingId = (id) => {
    setRenId(id);
  };
  const version = location.state?.version;

  const clearImplicitLineRatingDefault = (categories) => {
    categories?.forEach((category) => {
      category.lines?.forEach((line) => {
        const hasExplicitSelection =
          (Array.isArray(line.defaultRating_ids) && line.defaultRating_ids.length > 0) ||
          (Array.isArray(line.line_rating_data) && line.line_rating_data.length > 0);
        if (!hasExplicitSelection && Number(line.defaultRating_id) === 1) {
          line.defaultRating_id = null;
        }
      });
    });
  };

  const getCategoryList = (loader) => {
    if (loader === "noLoader") {
      setShowLoader(false);
    } else setShowLoader(true);

    const formdata = {
      template_id: templateIdRef.current,
      company_id: companyId,
      user_id: uuId,
      role_id: roleId,
    };
    apiCall(
      (response) => {
        const { status_code, data, message, success } = response.data;
        if (success) {
          clearImplicitLineRatingDefault(data.template?.categories);
          // Sort once here so the ratings panel and every line/comment rating dropdown share the
          // same order — the API doesn't guarantee it.
          const sortedRatings = sortRatingsByOrder(data.template?.rating_data);
          setTemplateRatingDetails(sortedRatings);
          setSummary({ innerHTML: data.template.summary_disclaimer || "" });
          const sortedData = data?.template
            ? { ...data, template: { ...data.template, rating_data: sortedRatings } }
            : data;
          setAllCategoryList(sortedData);
          setShowLoader(false);
          dispatch(updateTEData(sortedData));
          dispatch(updateCategoryData([]));
        } else {
          toast.error(message);
          if (status_code === 404) {
            navigate(`/templates/`);
            setShowLoader(false);
          }
        }
      },
      formdata,
      "GET_CATEGORY_LIST"
    );
  };

  // The ratings panel renders `templateRatingDetails`, which is otherwise only filled when the
  // template loads. Ratings can also arrive mid-session on `template.rating_data` — the comment
  // library adds one when a comment brings in a rating the template doesn't have — so mirror that
  // back here, otherwise the new rating is posted and saved but missing from the list until a
  // refresh. Compared by content so the shared array identity churn doesn't loop.
  useEffect(() => {
    const ratings = AllCategoryList?.template?.rating_data;
    if (!Array.isArray(ratings)) return;
    setTemplateRatingDetails((previous) =>
      ratingListSignature(previous) === ratingListSignature(ratings) ? previous : sortRatingsByOrder(ratings)
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [AllCategoryList?.template?.rating_data]);

  const GetTemplateDetail = (loader) => {
    if (loader === "noLoader") {
      setShowLoader(false);
    } else setShowLoader(true);

    const formdata = {
      company_id: companyId,
      user_id: uuId,
      role_id: roleId,
      template_id: templateIdRef.current,
    };

    apiCall(
      (response) => {
        const { data, message, success } = response.data;
        if (success) {
          setTemplateDetails(data);
          setDefaultTemplate(data.default);
        } else {
          navigate(`/templates/`);
        }
      },
      formdata,
      "TEMPLATE_DETAILS"
    );
  };

  const DiscardTemplateReq = () => {
    setShowLoader(true);
    const formdata = {
      company_id: companyId,
      user_id: uuId,
      role_id: roleId,
      template_id: templateIdRef.current,
    };

    apiCall(
      (response) => {
        const { data, message, success } = response.data;
        if (success) {
          navigate(`/templates/`);
          toast.success(message);
          setShowLoader(false);
        } else {
          console.error("else ", response.data.message);
        }
      },
      formdata,
      "DISCARD_TEMPLATE"
    );
  };

  const HandleOpenEditor = (type, open) => {
    setAddNew(open);
    setIsEdit(type);
    if (type === "edit") {
      setLoadDetails(loadDetails + 1);
    }
  };

  const PublishTemplate = () => {
    toast.dismiss();
    setShowLoader(true);
    AllCategoryList.user_id = uuId;
    AllCategoryList.company_id = companyId;
    AllCategoryList.role_id = roleId;
    setAutoSave(false);
    requestUpdate().then(() => {
      const formdata = {
        company_id: companyId,
        user_id: uuId,
        role_id: roleId,
        template_id: templateIdRef.current,
      };
      apiCall(
        (response) => {
          const { data, message, success } = response.data;
          if (success) {
            setShowLoader(false);
            toast.success(message);
            navigate(`/templates/`);
            dispatch(updateCategoryData([]));
          } else {
            console.error("else ", response.data.message);
            toast.error(response.data.message);
          }
        },
        formdata,
        "PUBLISH_TEMPLATE"
      );
    });
  };

  const TogglerSwitch = (newValue) => {
    setDefaultTemplate(newValue);
    defaultRef.current = newValue;
    queueUpdateTemplateData((updateTemplateData) => [...updateTemplateData, {}]);
    updateTemplateDataRef.current = [...updateTemplateData, {}];
    setAutoSave(true);
  };

  const updateTemplate = (toastStatus, toastMessage, dynamicToastFlag, addTagToCategoryFunctionCall, successfulFunction = successfulCategoryChange) => {
    queueUpdateTemplateCall((updateTemplateCall) => [
      ...updateTemplateCall,
      {
        status: toastStatus,
        message: toastMessage,
        toastFlag: dynamicToastFlag,
        categoryFunctionCall: addTagToCategoryFunctionCall,
      },
    ]);
    if (successfulFunction) {
      successfulFunction();
    }
    updateTemplateCallRef.current = [
      ...updateTemplateCall,
      {
        status: toastStatus,
        message: toastMessage,
        toastFlag: dynamicToastFlag,
        categoryFunctionCall: addTagToCategoryFunctionCall,
      },
    ];
    setAutoSave(true);
  };

  const successfulCategoryChange = () => {
    setRenId("");
    setShowLoader(false);
    setOutsideClick(false);
    setIsRename(false);
    setIsFocused(false);
  };

  const successfulRatingChange = () => {
    setReRender(!reRender);
    setAction("");
  };

  const requestUpdateTemplateData = async (updatePayload, updateQueue) => {
    return new Promise((resolve, reject) => {
      updatePayload.user_id = uuId;
      updatePayload.company_id = companyId;
      updatePayload.role_id = roleId;
      updatePayload.updated_at = timestamp();
      // The template default rating is only applied to lines/comments for display — never persist it,
      // otherwise it becomes a real selection and stops following the template's default.
      updatePayload.template.categories = stripDefaultRatingFromCategories(
        updatePayload.template.categories,
        updatePayload.template.rating_data || AllCategoryList?.template?.rating_data || [],
        !!storeData?.templateList?.is_global_rating_enabled
      );

      if (updateQueue.length > 0) {
        queueUpdateTemplateCall([]);
        apiCall(
          (response) => {
            const { status_code, data, message, success } = response.data;
            if (success) {
              let foundCategoryFunctionCall = false;
              updateQueue.forEach((updateCall) => {
                if (updateCall.categoryFunctionCall) {
                  foundCategoryFunctionCall = true;
                  updateCall.categoryFunctionCall();
                  setTimeout(() => {
                    setLoad(load + 1);
                  }, 1000);
                }
              });
              if (!foundCategoryFunctionCall) setLoad(load + 1);
              dispatch(updateCategoryData([]));
              resolve("finished");
            } else {
              toast.error(message);
              if (status_code === 404) {
                navigate(`/templates/`);
              } else if (status_code === 400 && message === "You can't edit template details after published.") {
                navigate(`/templates/`);
              }

              reject(new Error(message));
            }
          },
          updatePayload,
          "UPDATE_TEMPLATE_DATA"
        );
      } else {
        resolve("finished");
      }
    });
  };

  const requestUpdateTemplateDetails = async (updatePayload, dataQueue) => {
    return new Promise((resolve, reject) => {
      if (dataQueue.length > 0) {
        queueUpdateTemplateData([]);
        apiCall(
          (response) => {
            const { status_code, data, message, success } = response.data;
            setIsAutoSaving(false);
            if (success) {
              setLoad(load + 1);
              resolve("finished");
            } else {
              toast.error(message);
              if (status_code === 404) {
                navigate(`/templates/`);
              } else if (status_code === 400 && message === "You can't edit template details after published.") {
                navigate(`/templates/`);
              }

              reject(new Error(message));
            }
          },
          {
            user_id: uuId,
            company_id: companyId,
            role_id: roleId,
            template_id: updatePayload?.template?.id,
            name: updatePayload?.template?.name,
            description: updatePayload?.template?.description,
            inspection_type_id: updatePayload?.template?.inspection_type_id,
            default: defaultRef.current,
            is_active: updatePayload?.template?.is_active,
            line_level_rating: updatePayload?.template?.line_level_rating,
          },
          "UPDATE_TEMPLATE_DETAILS"
        );
      } else {
        resolve("finished");
      }
    });
  };

  const requestUpdate = async () => {
    toast.dismiss();
    setIsAutoSaving(true);
    setAutoSave(false);
    const state = store.getState();
    // Built from the live editor state, not from `templates.templateData` — that is only filled
    // when the template loads, and shares its `template` object with `AllCategoryList` so that
    // edits which mutate in place (rating add/edit/delete, the summary disclaimer) reach the save.
    // Most other edits replace `template` with a new object though, which disconnected the two and
    // silently dropped every later in-place edit from the payload — a deleted rating came back on
    // the next load. The ref is kept in sync with `AllCategoryList` on every render.
    const liveTemplateData = AllCategoryListRef.current?.template
      ? AllCategoryListRef.current
      : templateDataList;
    const updateTemplateDataResult = await requestUpdateTemplateData(
      { ...liveTemplateData, template: { ...liveTemplateData?.template, categories: state?.templates?.categoryList } },
      updateTemplateCallRef.current
    );
    const updateTemplateDetailsResult = await requestUpdateTemplateDetails(AllCategoryListRef.current, updateTemplateDataRef.current);
    if (updateTemplateDataResult === "finished" && updateTemplateDetailsResult === "finished") {
      toast.success("Your changes have been saved.");
    }
    setIsAutoSaving(false);
  };

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (autoSaveRef.current) {
        const message = "You have unsaved changes. Are you sure you want to leave?";
        event.returnValue = message;
        return message;
      }
    };

    const handlePopState = (event) => {
      if (autoSaveRef.current && !isNavigatingAway) {
        event.preventDefault();
        setShowNavigationConfirm(true);
        window.history.pushState(null, '', window.location.href);
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener('popstate', handlePopState);
    };
  }, [isNavigatingAway]);

  useEffect(() => {
    if (showNavigationConfirm) {
      const userConfirmed = window.confirm(
        "You have unsaved changes. Are you sure you want to leave?"
      );
      if (userConfirmed) {
        setIsNavigatingAway(true);
        requestUpdate().finally(() => {
          setIsNavigatingAway(false);
          setShowNavigationConfirm(false);
        });
      } else {
        setShowNavigationConfirm(false);
      }
    }
  }, [showNavigationConfirm]);

  useEffect(() => {
    autoSaveRef.current = autoSave;
    AllCategoryListRef.current = AllCategoryList;
  }, [autoSave, AllCategoryList]);

  useEffect(() => {
    const saveCheckTimeoutId = setTimeout(() => {
      if (isAutoSaving === false && autoSave === true) {
        requestUpdate();
      }
    }, autoSavingCheck);
    return () => {
      clearTimeout(saveCheckTimeoutId);
    };
  }, [autoSave, isAutoSaving]);

  const summaryEdit = () => {
    // Blank paragraphs the editor leaves behind would render as empty gaps in the report, so the
    // disclaimer is trimmed on the way out instead of being stored as typed.
    AllCategoryList.template.summary_disclaimer = trimEditorHtml(summary?.innerHTML?.replace("\n", ""));
    updateTemplate("showToast", "Summary Disclaimer has been saved", true);
  };

  const LoadList = (loader) => {
    loader = load > 0 ? "noLoader" : loader;
    getCategoryList(loader);
    GetTemplateDetail(loader);
  };

  useEffect(() => {
    if (AllCategoryList?.template?.categories?.length > 0) {
      setCategoryList((prev) => {
        const newCategoryList = [...AllCategoryList?.template?.categories];
        return newCategoryList;
      });
    }
  }, [AllCategoryList]);

  useEffect(() => {
    if (load === 0) {
      LoadList();
    }
  }, [load]);

  return (
    <>
      <div className="detail-card" draggable="false">
        <Preloader showPreloader={showLoader} />
        <div style={{ marginTop: isMobile && "25px" }} className="layout">
          <Grid container className="templates">
            <Grid item xs={6}>
              <Typography className="layout__title">{templateDetails?.name?.length > 50 ? `${templateDetails?.name?.substring(50, 0)}...` : templateDetails?.name} </Typography>
            </Grid>
            <Grid item xs={6}>
              <SettingsIcon id="template_setting_btn" onClick={() => HandleOpenEditor("edit", true)} className="templates__icon" sx={{ float: "right" }} />
            </Grid>
            <Grid item xs={12}>
              <p className="layout__description">{templateDetails.description ?? ""}</p>
            </Grid>
          </Grid>
          <InspectionDetails
            isFocused={setIsFocused}
            newList={newCatList}
            setNewList={setNewCatList}
            checkActiveFocus={checkActiveFocus}
            renId={renId}
            requestUpdate={requestUpdate}
            getCategoryList={getCategoryList}
            updateTemplateCallRef={updateTemplateCallRef}
            setSkeletonLoad={setSkeletonLoad}
            skeletonLoad={skeletonLoad}
            renamingId={(id) => renamingId(id)}
            isChanged={isRename}
            activeRename={() => setIsRename(true)}
            updateTemplate={updateTemplate}
            CategoryList={CategoryList}
            AllCategoryList={AllCategoryList}
            setAllCategoryList={setAllCategoryList}
            LoadList={(value) => {
              setLoad(load + 1);
              LoadList(value);
            }}
            TriggerClick={() => setOutsideClick(true)}
            outsideClick={outsideClick}
            templateId={templateIdRef.current}
            setShowLoader={setShowLoader}
            templateDetails={templateDetails}
          />
        </div>
        <div className="layout2">
          <CategoryDetails
            summaryEdit={summaryEdit}
            summary={summary}
            setSummary={setSummary}
            LoadList={() => setLoad(load + 1)}
            DiscardTemplateReq={DiscardTemplateReq}
            version={version}
            templateRatingDetails={templateRatingDetails}
            AllCategoryList={AllCategoryList}
            setAllCategoryList={setAllCategoryList}
            templateId={templateIdRef.current}
            templateName={templateName}
            TogglerSwitch={TogglerSwitch}
            templateDetails={templateDetails}
            PublishTemplate={PublishTemplate}
            updateTemplate={updateTemplate}
            autoSave={autoSave}
            isAutoSaving={isAutoSaving}
            requestUpdate={requestUpdate}
            reRender={reRender}
            setReRender={setReRender}
            action={action}
            setAction={setAction}
            successfulRatingChange={successfulRatingChange}
            defaultTemplate={defaultTemplate}
            getCategoryList={getCategoryList}
          />
        </div>
      </div>
      <EditTemplateList
        open={addNew}
        isEdit={isEdit}
        templateId={templateIdRef.current}
        refresh={loadDetails}
        load={() => setLoad(load + 1)}
        onClose={handleCloseNew}
        setTemplateDetails={setTemplateDetails}
      />
    </>
  );
};

export default EditTemplate;
